const CHARS_PER_PAGE = 2700;

export function getAnalysingTimeRemaining(
  textLength: number,
  creationDate: Date,
): number {
  if (textLength < 1000) {
    return 0;
  }
  const estimatedTime = (textLength / CHARS_PER_PAGE) * 4;
  const timeTaken =
    (new Date().valueOf() - new Date(creationDate).valueOf()) / 1000;
  return Math.max(20, estimatedTime - timeTaken);
}

export function getClassifyingTimeRemaining(
  clausepartLastEdited: string,
  classificationStart: string,
  clausepartLoadCount: number,
  clausepartLoadTotal: number,
  clausesLlmTimeEstimate?: number,
): number {
  if (clausesLlmTimeEstimate) {
    return clausesLlmTimeEstimate;
  }
  const timeTaken =
    (new Date(clausepartLastEdited).getTime() -
      new Date(classificationStart).getTime()) /
    1000;
  return (
    ((clausepartLoadTotal - clausepartLoadCount) * timeTaken) /
    clausepartLoadCount
  );
}
